import * as actionTypes from './actionTypes';
import RequestStates from '../../../utils/request-states';

const INITIAL_STATE = {
  currentDialogNames: [],
  web3: {}
};


// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.OPEN_DIALOG:
      return {
        ...state,
        currentDialogNames: [
          ...state.currentDialogNames,
          action.payload,
        ],
      };
    case actionTypes.CLOSE_DIALOG:
      return {
        ...state,
        currentDialogNames: state.currentDialogNames
          .filter(dialogName => dialogName !== action.payload),
        selectedTab: {},
      };
    case actionTypes.SET_WEB3:
      return {
        ...state,
        web3: {
          ...state.web3,
          ...action.payload
        }
      };
    default:
      return state;
  }
};
